import { render, staticRenderFns } from "./sbvParseList.vue?vue&type=template&id=1640915a&scoped=true"
import script from "./sbvParseList.vue?vue&type=script&lang=js"
export * from "./sbvParseList.vue?vue&type=script&lang=js"
import style0 from "./sbvParseList.vue?vue&type=style&index=0&id=1640915a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1640915a",
  null
  
)

export default component.exports